module.exports = __webpack_public_path__ + "static/media/plagiarism.6e79578b.svg";